"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocsTooltipContentError = DocsTooltipContentError;
var _react = _interopRequireDefault(require("react"));
var _Alert = _interopRequireDefault(require("mdi-material-ui/Alert"));
var _BaseTooltip = require("../../baseComponents/BaseTooltip");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var DOCS_URL = 'https://docs.tackle.io';
function DocsTooltipContentError(_ref) {
  var classes = _ref.classes;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_BaseTooltip.__BaseTooltipHeader, {
    classes: classes.header
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, null), "Error retrieving content"), /*#__PURE__*/_react.default.createElement(_BaseTooltip.__BaseTooltipContent, {
    classes: classes.content
  }, /*#__PURE__*/_react.default.createElement("p", null, "We\u2019re working on a fix. Until then, you can try searching Tackle Docs to find answers.")), /*#__PURE__*/_react.default.createElement(_BaseTooltip.__BaseTooltipFooter, {
    classes: classes.footer
  }, /*#__PURE__*/_react.default.createElement(_BaseTooltip.__BaseTooltipLink, {
    link: DOCS_URL,
    showExternalIcon: true
  }, "Tackle Docs")));
}